function EasyBundleHideSoldOut() {
  document.querySelectorAll('.product-detail-modal-content').forEach(modal => {
    const btn = modal.querySelector('cartmax-button');
    if (btn && btn.getAttribute('text') === 'Sold out') {
      modal.style.display = 'none';
    }
  });
}

EasyBundleHideSoldOut();

const observer = new MutationObserver(EasyBundleHideSoldOut);
observer.observe(document.body, { childList: true, subtree: true });

const domReady = () => {
    contentBasedOnSelectedState();
    initStateSelector();
    okendoReviewsHideZeroReviews();
    document.addEventListener('recentlyViewed:loaded', okendoReviewsHideZeroReviews);
}

const initStateSelector = () => {
    const containers = document.querySelectorAll('.js-site-state-selector-handle');

    if (containers.length) {

        containers.forEach(container => {
            const selectedState = document.documentElement.dataset.stateSelected;
            const label = container.querySelector('[data-store-label]');

            if (label && selectedState) {
                label.innerHTML = selectedState.toUpperCase();
            }

            container.addEventListener('click', (e) => {
                console.log({ e });
                if (document.getElementById(e.target.getAttribute('aria-controls'))) {
                    document.getElementById(e.target.getAttribute('aria-controls')).show();
                }
            })
        });
    }

    const selectedState = document.documentElement.dataset.stateSelected;
    if (selectedState && document.getElementById('state-selector')) {
        const stateSelector = document.getElementById('state-selector');
        stateSelector.value = selectedState;
    }
}

const contentBasedOnSelectedState = () => {
    // Content based on selected state
    // Reads off root element <html> attribute data-selected-state and uses CSS to hide/show content
    const selectedState = document.documentElement.dataset.stateSelected;
    const items = document.querySelectorAll('[data-state]');
    const sections = ['site-nav', 'slideshow', 'text-columns-icons', 'featured-collection'];

    if (selectedState) {
        const groupBySection = [...items].reduce((acc, el) => {
            const key = sections.find((s) => [...el.classList].includes(s));
            const curGroup = acc[key] ?? [];
            return { ...acc, [key]: [...curGroup, el] };
        }, {});

        for (const arr of Object.values(groupBySection)) {
            const hasSelectedState = arr.filter((el) => el.dataset.state === selectedState);

            if (hasSelectedState.length) {
                arr.forEach((el) => el.classList.remove('is-visible'));
                hasSelectedState.forEach((el) => el.classList.add('is-visible'));
            } else {
                arr
                    .filter((el) => el.dataset.state === 'DEFAULT')
                    .forEach((el) => el.classList.add('is-visible'))
            }
        }
    } else {
        [...items]
            .filter((el) => el.dataset.state === 'DEFAULT')
            .forEach((el) => el.classList.add('is-visible'));
    }

    document.dispatchEvent(new CustomEvent('stateBasedContent:loaded'));
}

document.addEventListener('DOMContentLoaded', domReady);

// START GLOBAL AJAX ADD TO CART FUNCTIONS

// add multiple products to cart
const addProductsToCart = (arr = []) => {
    // Example: arr = [{id: '1234', quantity: 1, properties: {}}, {id: '2345', quantity: 2}]
    if (arr.length === 0) return;

    let items = arr;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: { items },
        dataType: 'json',
        success: function () {
            // update cart
            window.refreshCart()

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}

// add single product to cart
const addProductToCart = (variant_id = '', qty = 0, properties = null) => {
    if (!variant_id || variant_id == '' || qty === 0) return;

    let data = {
        "id": variant_id,
        "quantity": qty
    }

    if (properties) {
        data["properties"] = properties;
    }

    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function () {
            // update cart
            window.refreshCart();

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}

// Remove item from cart
const removeItemFromCart = (key) => {
    if (!key) return;

    let updates = {}
    updates[key] = 0;

    jQuery.ajax({
        type: 'POST',
        url: '/cart/update.js',
        data: { updates },
        dataType: 'json',
        success: function (res) {
            // update cart
            window.refreshCart();

            document.dispatchEvent(new CustomEvent('cart:refreshed'));
        }
    });
}
// END GLOBAL AJAX ADD TO CART FUNCTIONS

window.addEventListener('DOMContentLoaded', () => {
    // SWYM WISHLIST ATC
    // $(document).on('click', '.swym-close-btn', () => {
    //     setTimeout(() => {
    //         window.refreshCart();
    //     }, 1000);
    // })

    // CART RECOMMENDATIONS SLIDER
    $(document).on('click', '.recommendations-slide__atc-btn', (e) => {
        const btn = e.currentTarget;
        const id = btn.getAttribute('data-id');

        if (!id || id == '') return;

        addProductToCart(id, 1);
    })

    // CART FREE GIFT SLIDER
    $(document).on('click', '.cart-free-gift-slide__atc-btn', (e) => {
        const btn = e.currentTarget;
        const id = btn.getAttribute('data-id');

        if (!id || id == '') return;

        addProductToCart(id, 1, { "_freeGift": true });
    })

    document.addEventListener('cart:refreshed', async (e) => {
        let cartContents = await fetch('/cart.js')
            .then(response => response.json())
            .then(data => { return data });

        // cartContents.items.forEach(item => {
        //     if (item.properties?.["_freeGift"] && item.final_price > 0) {
        //         removeItemFromCart(item.key);
        //     }
        // });
    })

    // SAME DAY DISPATCH TIMER
    const dispatch_countdown_sections = document.querySelectorAll('.cart-dispatch-timer');
    const initSameDayDispatchTimer = (elem) => {
        console.log({ elem })
        // ELEMENTS
        const dispatchTimer_hours = elem.querySelector('[data-timer-hours]');
        const dispatchTimer_mins = elem.querySelector('[data-timer-minutes]');
        const dispatchTimer_secs = elem.querySelector('[data-timer-seconds]');

        // CURRENT TIME
        const m = dayjs().get('month') + 1;
        const d = dayjs().get('date');

        const currYear = dayjs().get('year');
        const currMonth = m < 10 ? '0' + m : m;
        const currDay = d < 10 ? '0' + d : d;

        // CHECK DEADLINE
        let d_h = parseInt(elem.getAttribute('data-h'));
        d_h = d_h < 10 ? '0' + d_h : d_h;
        let d_m = parseInt(elem.getAttribute('data-m'));
        d_m = d_m < 10 ? '0' + d_m : d_m;
        let d_t = Math.abs(parseInt(elem.getAttribute('data-t')));

        let sign = d_t < 0 ? '-' : '+';

        const deadlineString = `${currYear}-${currMonth}-${currDay}T${d_h}:${d_m}:00${sign}${d_t}:00`;
        const deadline = dayjs(deadlineString)

        // CALCULATIONS
        let isAfter = dayjs().isAfter(deadline);

        if (isAfter) {
            // hide element
            elem.style.display = 'none';
        } else {
            // start countdown
            const dispatchInterval = setInterval(() => {
                let diff = deadline.diff(dayjs(), 'second');

                let diff_s = Math.floor(diff % 60);
                let diff_m = Math.floor(diff / 60 % 60);
                let diff_h = Math.floor(diff / 60 / 60 % 60);

                dispatchTimer_hours.innerHTML = diff_h;
                dispatchTimer_mins.innerHTML = diff_m < 10 ? `0${diff_m}` : diff_m;
                dispatchTimer_secs.innerHTML = diff_s < 10 ? `0${diff_s}` : diff_s;

                if (diff < 1) {
                    clearInterval(dispatchInterval);
                    elem.style.display = 'none';
                }
            }, 1000);

            setTimeout(() => {
                elem.style.display = 'block';
            }, 1000)
        }
    }

    for (elem of [...dispatch_countdown_sections]) {
        initSameDayDispatchTimer(elem);
    }

    document.addEventListener('cart:refreshed', () => {
        setTimeout(() => {
            for (elem of [...dispatch_countdown_sections]) {
                initSameDayDispatchTimer(elem);
            }
        }, 1000);
    });


    // FAQ
    const faqNav = document.querySelectorAll('.horizontal-nav button');

    for (var x = 0; x < faqNav.length; x++) {

        faqNav[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;

            // inactive all button
            for (var i = 0; i < faqNav.length; i++) {
                faqNav[i].closest('li').classList.remove('active')
            }

            // active selected
            e.target.closest('li').classList.add('active');

            // inactive all title
            for (var i = 0; i < document.querySelectorAll('.grid-title h2').length; i++) {
                document.querySelectorAll('.grid-title h2')[i].classList.remove('active')
            }

            // active selected title
            document.querySelector('.grid-title h2[data-parent="' + parent + '"]').classList.add('active');

            // close all
            for (var i = 0; i < document.querySelectorAll('.grid-tab_item').length; i++) {
                document.querySelectorAll('.grid-tab_item')[i].classList.remove('open')
            }

            // open selected
            for (var i = 0; i < document.querySelectorAll('.grid-tab_item[data-parent="' + parent + '"]').length; i++) {
                document.querySelectorAll('.grid-tab_item[data-parent="' + parent + '"]')[i].classList.add('open')
            }
        });
    }


    if (faqNav[0]) {
        faqNav[0].click();
    }

    const faqQA = document.querySelectorAll('.grid-tab_item button');

    for (var x = 0; x < faqQA.length; x++) {
        faqQA[x].addEventListener('click', function (e) {
            var parent = e.target.dataset.parent;

            // inactive all button
            // for (var i = 0; i < faqQA.length; i++) {
            //     faqQA[i].closest('.grid-tab_item').classList.remove('active')
            // }

            // active selected
            e.target.closest('.grid-tab_item').classList.toggle('active');
        });
    }

    const selectEl = document.querySelector('.product-text [name="id"]');

    if (selectEl) {
        selectEl.addEventListener('change', function (event) {
            var getVariantId = this.value;

            // for variant meta description
            const variantDescription = document.querySelectorAll('.variant-description');

            if (variantDescription.length > 0) {
                for (var x = 0; x < variantDescription.length; x++) {
                    variantDescription[x].classList.remove('active')
                }

                if (document.querySelector('[data-variant="' + getVariantId + '"]') != null) {
                    document.querySelector('[data-variant="' + getVariantId + '"]').classList.add('active');
                }

                if (document.querySelector('.collapsible-trigger-btn.is-open')) {
                    document.querySelector('.collapsible-trigger-btn.is-open').click();
                }
            }
        });
    }
})

const okendoReviewsHideZeroReviews = () => {
    const reviewsEl = document.querySelectorAll('.product-item__ratings');
    reviewsEl.forEach(el => {
        if (el.querySelector('.oke-sr-count-number')) {
            const reviews = el.querySelector('.oke-sr-count-number').innerText;
            if (reviews == "0") {
                el.classList.add('hide-reviews');
            }
        }
    })
}

$(document).on('change', "[name='note']", updateNotes);

function updateNotes(e) {
    var note = e.target.value;
    var obj = JSON.stringify({ note: note });
    console.log('updating notes');

    //#! Update attributes
    fetch('/cart/update.js', {
        method: 'POST',
        body: obj,
        headers: { 'Content-type': 'application/json; charset=UTF-8' },
    });
}

// Function prevent to redirect to page cart when clicked clear cart button
$(document).on('click', "#site-cart-sidebar .cart__clear-all > a", clearCart);
async function clearCart(event) {
    event.preventDefault();
    event.target.classList.add('working'); // Add class working to show up loader animation
    const urlClearCart = event.target.href;
    const result = await fetch(urlClearCart)
        .then(res => {
            const cartNotes = document.querySelector("[name='note']");
            cartNotes.value = ""; // Reset cart notes because there is no longer cart items to checkout
            window.refreshCart();
            event.target.classList.remove('working'); // Add class working to show up loader animation
        })
};